var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.listCount > _vm.pageSize)?_c('v-pagination',{staticClass:"component-pagination",attrs:{"length":_vm.pages,"circle":"","color":"#4487C8","total-visible":7},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }